import type { Company } from "kubb";
import type { Scheme } from "kubb";
import { isString } from "lodash-es";

export const getUrlHash = (
  selectedCompany?: Company | string,
  selectedScheme?: Scheme | string,
  privacyMode = false,
): string => {
  const companyHash = selectedCompany
    ? `company=${
        isString(selectedCompany) ? selectedCompany : selectedCompany.company_id
      }`
    : "company=NONE";
  const schemeHash = selectedScheme
    ? `scheme=${
        isString(selectedScheme) ? selectedScheme : selectedScheme.scheme_id
      }`
    : "";
  let hash: string;
  if (companyHash !== "" && schemeHash !== "") {
    hash = [companyHash, schemeHash].join("&");
  } else {
    if (companyHash !== "") {
      hash = companyHash;
    } else {
      hash = schemeHash;
    }
  }
  if (privacyMode) {
    const privacyModeHash = "privacy=true";

    if (hash) {
      hash = [hash, privacyModeHash].join("&");
    } else {
      hash = privacyModeHash;
    }
  }
  return `#${hash}`;
};

export function parseHash(hash: string): { [key: string]: string } {
  return Object.fromEntries(
    hash
      .substring(1)
      .split("&")
      .map((v) => {
        return v.split("=");
      }),
  );
}

export const selectPropertyFromLocationHash = (
  param: string,
  hash: string | undefined,
): string | undefined => {
  if (hash) {
    const params = parseHash(hash);
    if (params[param]) {
      if (params[param] === "undefined" || params[param] === "null") {
        return undefined;
      }
      return params[param];
    }
  }
  return undefined;
};
